export default [

     {
          path: '/operating-system',
          name: 'OperatingSystem',
          component: () => import("@/views/Page/OperatingSystem/OperatingSystem.vue"),
           meta: {
               title: 'Operating System',
          },
     }
];